<template>
  <div class="ProgramActivityLevel-view-page w-100">
    <basic-subheader>
      <template v-slot:actions>
        <b-button class="btn ml-3" type="button" @click="returnPage">
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Arrows/arrow-left.svg" />
          </span>
          Trở về trước
        </b-button>
        <b-button
          class="btn btn-inactive ml-3"
          type="button"
          v-if="programActivityLevelData.isActive && isDeletePermission"
          @click="handleInactive(programActivityLevelData)"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/power.svg" />
          </span>
          Inactive
        </b-button>
        <b-button
          class="btn btn-active ml-3"
          type="button"
          v-if="!programActivityLevelData.isActive && isDeletePermission"
          @click="handleInactive(programActivityLevelData)"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/power.svg" />
          </span>
          Active
        </b-button>
        <b-button
          class="btn btn-success ml-3"
          type="button"
          v-if="isDeletePermission"
          @click.stop="handleUpdate(programActivityLevelData)"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/edit-2.svg" />
          </span>
          Chỉnh sửa
        </b-button>
      </template>
    </basic-subheader>
    <b-overlay :show="loading">
      <b-container fluid class="ProgramActivityLevel-view-page__body mb-6 mt-6">
        <b-row Class="mt-8">
          <b-col>
            <div class="text-muted">Mã:</div>
            <div>
              {{ programActivityLevelData.code }}
            </div>
          </b-col>
          <b-col>
            <div class="text-muted">Tên:</div>
            <div>
              {{ programActivityLevelData.name }}
            </div>
          </b-col>
          <b-col>
            <div class="text-muted">Trạng thái xóa:</div>
            <div>
              {{
                programActivityLevelData.isDeleted ? 'Đã bị xóa' : 'Chưa bị xóa'
              }}
            </div>
          </b-col>
          <b-col>
            <div class="text-muted">Vị trí hiển thị:</div>
            <div>
              {{ programActivityLevelData.displayIndex }}
            </div>
          </b-col>
          <b-col>
            <div class="text-muted">Trạng thái hoạt động:</div>
            <div>
              {{
                programActivityLevelData.isActive
                  ? 'Hoạt động'
                  : 'Không hoạt động'
              }}
            </div>
          </b-col>
        </b-row>
        <b-row Class="mt-8">
          <b-col>
            <div class="text-muted">Ngày tạo:</div>
            <div>
              {{
                convertTimestampToDate(
                  programActivityLevelData.createDatetime,
                  'DD/MM/YYYY HH:mm:ss',
                )
              }}
            </div>
          </b-col>
          <b-col>
            <div class="text-muted">Ngày chỉnh sửa:</div>
            <div>
              {{
                convertTimestampToDate(
                  programActivityLevelData.updateDatetime,
                  'DD/MM/YYYY HH:mm:ss',
                )
              }}
            </div>
          </b-col>
        </b-row>
        <b-row Class="mt-8">
          <b-col>
            <div class="text-muted">Tên người tạo:</div>
            <div>
              {{ CreateCurrentInfo.fullName }}
            </div>
          </b-col>
          <b-col>
            <div class="text-muted">Tên người chỉnh sửa:</div>
            <div>
              {{ UpdateCurrentInfo.fullName }}
            </div>
          </b-col>
        </b-row>
        <b-row Class="mt-8">
          <b-col>
            <div class="text-muted">Ghi chú:</div>
            <div>
              {{ programActivityLevelData.note }}
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      isFirstLoad: false,
      ProgramActivityLevelData: {},
      CreateCurrentInfo: {},
      UpdateCurrentInfo: {},
    };
  },
  computed: {
    ...mapGetters(['currentUser']),
    isDeletePermission() {
      let roles = this.currentUser?.roles;
      if (roles && roles.length) {
        return roles.includes('Admin');
      } else {
        return false;
      }
    },
  },
  methods: {
    returnPage() {
      this.$router.push({
        name: 'program_activity_level_list',
      });
    },
    handleUpdate(item) {
      this.$router.push({
        name: 'programActivityLevel_detail',
        params: {
          form_type: 'edit',
          id: item.id,
        },
      });
    },
    handleInactive(item) {
      let text = item.isActive ? 'Inactive' : 'Active';
      let btn = item.isActive ? 'btn-inactive' : 'btn-active';
      this.$swal({
        title: '',
        text: `Bạn có chắc muốn ${text} app user ${item.id} không?`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: 'btn btn-secondary',
            closeModal: true,
          },
          confirm: {
            text: `${text}`,
            value: true,
            visible: true,
            className: `btn ${btn}`,
            closeModal: true,
          },
        },
      }).then(
        function (result) {
          if (result) {
            // inactive all
            this.inactiveItem(item)
              .then(() => {
                this.loadProgramActivityLevelData();
                this.$swal(
                  'Thành công!',
                  'Chúc mừng, bạn đã cập nhật thông tin ProgramActivityLevel thành công!',
                  'success',
                );
              })
              .catch(() => {
                this.$swal('Lỗi!', 'Đã có lỗi xảy ra.', 'error');
              });
          }
        }.bind(this),
      );
    },
    async inactiveItem(item) {
      this.loading = true;
      try {
        let payload = new FormData();
        payload.append('id', item.id);
        payload.append('active', !item.isActive);
        await this.$api.put(`ProgramActivityLevel`, payload);
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
    async loadProgramActivityLevelData() {
      if (!this.$route.params.id) return;
      try {
        this.loading = true;
        const id = this.$route.params.id;
        let { data } = await this.$api.get(`ProgramActivityLevel/${id}`);
        this.programActivityLevelData = data;
        await this.fetchAccountInfo();
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchAccountInfo() {
      try {
        const { creatorId, updaterId } = this.programActivityLevelData || {};
        if (!creatorId && !updaterId) {
          throw new Error('Không tìm thấy creatorId hoặc updaterId');
        }
        const results = await Promise.all([
          creatorId
            ? this.$api
                .get(`Account?id=${creatorId}`)
                .then(({ data }) => data[0])
                .catch(() => null)
            : Promise.resolve(null),
          updaterId
            ? this.$api
                .get(`Account?id=${updaterId}`)
                .then(({ data }) => data[0])
                .catch(() => null)
            : Promise.resolve(null),
        ]);
        this.CreateCurrentInfo = results[0];
        this.UpdateCurrentInfo = results[1];
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error.message || error,
        });
      }
    },
  },
  mounted() {
    this.loadProgramActivityLevelData();
  },
};
</script>
